import { render, staticRenderFns } from "./invoiceRecord.vue?vue&type=template&id=bcb1e178&scoped=true&"
import script from "./invoiceRecord.vue?vue&type=script&lang=js&"
export * from "./invoiceRecord.vue?vue&type=script&lang=js&"
import style0 from "./invoiceRecord.vue?vue&type=style&index=0&id=bcb1e178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb1e178",
  null
  
)

export default component.exports